export class FileUpload{
    public id : number;
    public filegroup : '';
    public parentid :string;
    public remarks :''
    public validfrom :string;
    public validupto :string;
    public uom :'';
    public documentreminder :number = 1;
    public documentid :'';
}